import React, { useState } from "react";
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from "reactstrap";

const FAQAccordion = ({ faqData }) => {
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggle = (id) => {
    setOpenAccordion(prev => {
      // If the clicked accordion is already open, close it
      // Otherwise, open the clicked accordion (this will close any other open one)
      return prev === id ? null : id;
    });
  };

  return (
    <div className="faq-accordion reasonable_mrgn">
      <Accordion open={openAccordion} toggle={toggle}>
        {faqData.map((faq, index) => (
          <AccordionItem key={index}>
            <AccordionHeader targetId={`faq-${index}`}>
              {/* <strong>{faq.question}</strong> */}
              {faq.question}
            </AccordionHeader>
            <AccordionBody accordionId={`faq-${index}`}>
              <ul className="workingPoints_list">
                {faq.points?.map((sentence, pointIndex) => (
                  <li className="mt-2" key={pointIndex}>
                    <i className='ri-check-double-line list_ck_icn'></i> 
                    <p className="mb-0 listCont">
                      {sentence}
                    </p>
                  </li>
                ))}
              </ul>
            </AccordionBody>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQAccordion; 